'use client'

export function AiChatPage() {
  return (
    <div className="py-6">
      <h1 className="text-[1.75rem] font-bold tracking-tight leading-none">AI</h1>
      <p className="text-sm text-muted-foreground/55 mt-1.5">Coming soon.</p>
    </div>
  )
}
